import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import ebimbingan from "../../asset/ebimbingan.png";

type VerifyStatus = "loading" | "success" | "error";

export function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState<VerifyStatus>("loading");
  const [error, setError] = useState<string | null>(null);
  const token = searchParams.get("token");

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setStatus("error");
        setError("Token tiada dalam pautan.");
        return;
      }

      try {
        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/email/verify?token=${encodeURIComponent(
            token
          )}`
        );

        if (res?.data?.ok) {
          setStatus("success");
          Swal.fire({
            icon: "success",
            title: "Emel Disahkan",
            text: "Akaun anda kini telah disahkan.",
          });
          setTimeout(() => navigate("/login"), 300);
        } else {
          const errorMessage = res?.data?.error?.message || "Pengesahan gagal.";
          setStatus("error");
          setError(errorMessage);
          Swal.fire({
            icon: "error",
            title: "Pengesahan gagal",
            text: errorMessage,
          });
        }
      } catch (err: any) {
        const errorMessage =
          err?.response?.data?.error?.message ||
          err?.response?.data?.message ||
          err?.message ||
          "Pengesahan gagal.";
        setStatus("error");
        setError(errorMessage);
        Swal.fire({
          icon: "error",
          title: "Ralat",
          text: errorMessage,
        });
      }
    };

    verifyEmail();
  }, [navigate, token]);

  return (
    <div className="h-screen overflow-auto pt-5 pb-3 px-3 bg-white">
      <div className="text-center">
        <img src={ebimbingan} className="mb-5 mx-auto" alt="logo" />
        <p className="text-2xl font-bold">Sahkan Emel Anda</p>
        <p className="text-md text-gray-500">
          Kami sedang memproses pengesahan emel anda...
        </p>
      </div>

      <div className="text-center mt-10">
        {status === "loading" && (
          <div>
            <span className="inline-block h-8 w-8 border-4 border-lime-700 border-t-transparent rounded-full animate-spin" />
            <p className="mt-3">Sila tunggu...</p>
          </div>
        )}

        {status === "success" && (
          <p className="text-lg text-green-600 font-bold">
            Emel berjaya disahkan ✅
          </p>
        )}

        {status === "error" && (
          <p className="text-lg text-red-600 font-bold">❌ {error}</p>
        )}
      </div>

      <div className="mt-6 text-center">
        <button
          type="button"
          className="text-gray-500 hover:underline"
          onClick={() => navigate("/login")}
        >
          Kembali ke daftar masuk
        </button>
      </div>
    </div>
  );
}
